module.exports = {
    "toolbarTip": "此预览工具栏，不会出现在最终发布的项目中",
    "variableSettings": "变量设置",
    "previewTitle": "当前为预览模式",
    "varDlgTitle": "环境变量设置",
    "varConsistsTips": "【客户端变量】必须由数字、下划线、单词组成，如：1-CURR_YEAR；【服务端变量】必须由单词组成，如：USER_ID。",
    "save": "保存",
    "edit": "编辑",
    "delete": "删除",
    "add": "添加",
    "addVar": "添加变量",
    "value": "值",
    "type": "类型",
    "scope": "域",
    "operations": "操作",
    "cancel": "取消",
    "varUnstored": "有变量未完成编辑",
    "varName": "变量名",
    "dataBridgeError": "数据桥响应错误，请打开浏览器控制台查看更多细节。",
    "widgetDevError": "[Widget Dev Error] 无效的数据源 ID",
    "lpSyntaxError": "[Local Process Syntax Error] 本地处理函数有语法错误：",
    "lpExeError":"[Local Process Executing Error] 执行本地处理函数时发生错误：",
    "mockError":"[JSON Format Error] 无效的模拟数据： ",
    "staticError": "[JSON Format Error] 静态数据源不是一个合法的 JSON：",
    "jsonpError": "jsonp 调用失败。",
    "httpJsonErr": "[JSON Format Error] Http 接口返回的数据不是一个合法的 JSON： ",
    "customInterfaceErr": "[Dev Error] 请求自定义接口{{name}}发生错误",
    "dscallbackErr": "[Dev Error] 请求数据源后，执行回调函数发生错误，打开控制台查看更多细节。",
    "standaloneMode": "独立模式",
    "integratedMode": "集成模式",
    "switchRole": "角色切换",
    "cantViewStandalone": "无法预览，请先在菜单中打开页面",
    "unlimited": "不限制",
    "beforeExit": "确定要退出吗？",
    "logoutFailedMsg": "注销失败，请直接关闭窗口。",
    "upBridgeTip": "您需要将桥升级到 {{version}} 以上才能正常预览项目。升级指令：npm install -g enhancer-data-bridge"
};


//////////////////
// WEBPACK FOOTER
// ./src/tools/i18n/locale.zh-cn.js
// module id = 6
// module chunks = 0 1 2